export const dropDownMenu = () => {
  const triggers: Element[] = [...document.getElementsByClassName('js-dropdown-trigger')]
  const menus = triggers.map(trigger => document.getElementById((trigger as HTMLElement).dataset.trigger));
  const closeAllMenus = () => {
    menus.forEach(menu => {
      if (menu) {
        menu.classList.remove('is-active');
      }
    });
    triggers.forEach(trigger => {
      trigger.classList.remove('is-active')
    })
  };
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.stopPropagation()
      const context = document.getElementById((trigger as HTMLElement).dataset.trigger)
      if (context) {
        trigger.classList.toggle('is-active')
        context.classList.toggle('is-active')
      }
    })
  })
  document.addEventListener('click', (event) => {
    const target = event.target as Node
    const isClickInsideMenu = menus.some(menu => menu && menu.contains(target))
    const isClickInsideTrigger = triggers.some(trigger => trigger.contains(target))

    if (!isClickInsideMenu && !isClickInsideTrigger) {
      closeAllMenus();
    }
  });
}
